import _find from 'lodash/find'

const getPollById = (state) => (pollId) => {
 return _find(state.polls, (o) => {
   return o.id === pollId
  })
};

export default {
  getPollById
};
